export default {
    path: "/exportPage",
    name: "exportPage",
    meta: {
        title: "其他应用引入"
    },
    props: true,
    component: () => import("@/views/exportPage/exportPage.vue"),
    children: [
        {
            path: "/userInfo",
            name: "userInfo",
            meta: {
                title: "个人信息",
                norpermission: true
            },
            component: () => import("@/views/own/baseInfo.vue")
        }
    ]
};



// WEBPACK FOOTER //
// ./src/router/modules/exportPage.js